import { PatientSubRole, SubNavItem, UserType } from '../interface/interface';
import {
  MedicationPrescribeIcon,
  DosageDiaryIcon,
  OrderHistoryIcon,
  MonthlyLimitIcon,
} from '../assets/svgImages';

export const useSubNavItems = (
  dropdownLink: UserType[],
  patientRole: PatientSubRole | undefined,
) => {
  const iconMap: Record<string, JSX.Element> = {
    [SubNavItem.MEDICATION_INFORMATION]: (
      <MedicationPrescribeIcon className="h-6 w-6" />
    ),
    [SubNavItem.DOSING_DIARIES]: <DosageDiaryIcon className="h-6 w-6" />,
    [SubNavItem.ORDER_HISTORY]: <OrderHistoryIcon className="h-6 w-6" />,
    [SubNavItem.MONTHLY_LIMITS]: <MonthlyLimitIcon className="h-6 w-6" />,
  };

  return dropdownLink
    .filter((link) => (link.specificAccessRole ?? patientRole) === patientRole)
    .map((link) => ({
      name: link.name,
      href: link.href,
      icon: iconMap[link.name] ?? <></>,
    }));
};
